require("!!/app/SPA/node_modules/script-loader/addScript.js")(require("!!/app/SPA/node_modules/raw-loader/index.js!/app/SPA/node_modules/bootstrap/dist/js/bootstrap.js"))


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/script-loader!/app/SPA/~/bootstrap/dist/js/bootstrap.js
// module id = ../../../../script-loader/index.js!../../../../bootstrap/dist/js/bootstrap.js
// module chunks = 3